const config = {
    SESSION_KEY: "AJ2sj09_KSsa200m",
    SESSION_ID: "SESSION_ID",
    X_SERVICE_PROVIDER: "sbremit-web-uat"
}

export default config;